import IApplicationVm from "../../shared/IApplicationVm"
import ICompanyVm from "../../shared/ICompanyVm"
import IReceiptVm from "../../shared/IReceiptVm"
import { InvoiceStatusType } from "../../enums/InvoiceStatusType"
import { PaymentType } from "../../enums/PaymentType"

import * as IApplicationVmInstance from "../../shared/IApplicationVm"
import * as ICompanyVmInstance from "../../shared/ICompanyVm"
import * as IReceiptVmInstance from "../../shared/IReceiptVm"

export default interface IInvoiceVm {
    id: string
    application: IApplicationVm
    number: number
    amount: string
    status: InvoiceStatusType
    paymentType: PaymentType
    transactionId: string
    cardType: string
    cardNumber: string
    paymentDate: string
    lockedTime?: string
    paymentLinkSentAttempts: number
    companyBilled: ICompanyVm
    isInvoiceLocked: boolean
    isInvoicePaid: boolean
    isInvoicePending: boolean
    areTermsAndConditionsAccepted: boolean
    receipt: IReceiptVm
    createdDate: string
    bulkParentInvoice: IInvoiceVm
    bat1PaymentRecordId?: number
    bat1PaymentIdent: string
}

export const empty = (enableIteration: boolean = true): IInvoiceVm => {
	return {
		id: "",
		application: IApplicationVmInstance.empty(),
		number: -1,
		amount: "",
		status: InvoiceStatusType.NotSet,
		paymentType: PaymentType.NotSet,
		transactionId: "",
		cardType: "",
		cardNumber: "",
		paymentDate: "",
		lockedTime: "",
		paymentLinkSentAttempts: -1,
		companyBilled: ICompanyVmInstance.empty(),
		isInvoiceLocked: false,
		isInvoicePaid: false,
		isInvoicePending: false,
		areTermsAndConditionsAccepted: false,
		receipt: IReceiptVmInstance.empty(),
		createdDate: "",
		bulkParentInvoice: enableIteration ? empty(false) : null,
		bat1PaymentRecordId: -1,
		bat1PaymentIdent: ""
	} as IInvoiceVm
}